<template>
  <div class="leaderboardMedium" id="leaderboardMedium">
    <div class="title">Leaderboard (Medium Montages)</div>
    <ul class="tabList">
      <li :class="{ active: activeTabMedium === 0 }" @click="setActiveTabMedium(0)"><b></b>Form</li>
      <li :class="{ active: activeTabMedium === 1 }" @click="setActiveTabMedium(1)"><b></b>Chart</li>
    </ul>
    <div class="board_tabs_Medium">
      <div class="item" v-if="activeTabMedium === 0">
        <div class="table_wrapper">
          <el-table
            class="Leaderboard_table"
            :data="tableDataMedium"
            :default-sort="{ prop: 'Avg', order: 'descending' }"
            style="width: 100%"
            max-height="500"
            @sort-change="handleSortChange"
          >
            <el-table-column label="" width="50">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="methods" :render-header="renderHeader('Methods')" width="160"></el-table-column>
            <el-table-column label="Medium Object Needle Grounding">
              <el-table-column prop="objRecall07" sortable :render-header="renderHeader('Recall@1x,<br>tIoU=0.7')" :formatter="formatNumber" width="160"></el-table-column>
              <el-table-column prop="objRecall05" sortable :render-header="renderHeader('Recall@1x,<br>tIoU=0.5')" :formatter="formatNumber" width="160"></el-table-column>
              <el-table-column
                prop="objmAP"
                sortable
                :render-header="renderHeader('Average<br>&nbsp;&nbsp;&nbsp;&nbsp;mAP')"
                :formatter="formatNumber"
                width="140"
              ></el-table-column>
            </el-table-column>
            <el-table-column label="Medium Scene Needle Grounding">
              <el-table-column prop="sceneRecall07" sortable :render-header="renderHeader('Recall@1x,<br>tIoU=0.7')" :formatter="formatNumber" width="160"></el-table-column>
              <el-table-column prop="sceneRecall05" sortable :render-header="renderHeader('Recall@1x,<br>tIoU=0.5')" :formatter="formatNumber" width="160"></el-table-column>
              <el-table-column
                prop="scenemAP"
                sortable
                :render-header="renderHeader('Average<br>&nbsp;&nbsp;&nbsp;&nbsp;mAP')"
                :formatter="formatNumber"
                width="140"
              ></el-table-column>
            </el-table-column>
            <el-table-column prop="Avg" sortable :render-header="renderHeader('Avg Recall@1x,<br>tIoU=0.7')" width="190" :formatter="formatNumber"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="item" v-if="activeTabMedium === 1">
        <LineChartMedium></LineChartMedium>
      </div>
    </div>
  </div>
</template>

<script>
import LineChartMedium from "./LineChartMedium.vue";
export default {
  name: "LeaderboardMedium",
  components: { LineChartMedium },
  data() {
    return {
      activeTabMedium: 0,
      tableDataMedium: [
        {
          methods: "MiniCPM v2.6-8B",
          objRecall07: 0.23,
          objRecall05: 0.68,
          objmAP: 4.79,
          sceneRecall07: 0.74,
          sceneRecall05: 2.22,
          scenemAP: 6.48,
          Avg: 0.49,
        },
        {
          methods: "Time-R1-3B",
          objRecall07: 0.45,
          objRecall05: 1.36,
          objmAP: 4.27,
          sceneRecall07: 0.74,
          sceneRecall05: 2.47,
          scenemAP: 5.81,
          Avg: 0.6,
        },
        {
          methods: "LongVU-7B",
          objRecall07: 0.68,
          objRecall05: 1.82,
          objmAP: 3.56,
          sceneRecall07: 1.23,
          sceneRecall05: 2.22,
          scenemAP: 4.05,
          Avg: 0.96,
        },
        {
          methods: "E.T. Chat-3.8B",
          objRecall07: 0.76,
          objRecall05: 1.76,
          objmAP: 4.25,
          sceneRecall07: 1.62,
          sceneRecall05: 3.5,
          scenemAP: 6.27,
          Avg: 1.19,
        },
        {
          methods: "LLVA-Video-72B",
          objRecall07: 1.59,
          objRecall05: 2.5,
          objmAP: 6.82,
          sceneRecall07: 0.99,
          sceneRecall05: 2.96,
          scenemAP: 8.72,
          Avg: 1.29,
        },
        {
          methods: "Qwen2.5-VL-7B",
          objRecall07: 5.39,
          objRecall05: 7.49,
          objmAP: 21.25,
          sceneRecall07: 8.28,
          sceneRecall05: 13.45,
          scenemAP: 29.55,
          Avg: 6.83,
        },
        {
          methods: "Time-R1-7B",
          objRecall07: 7.95,
          objRecall05: 15.91,
          objmAP: 35.33,
          sceneRecall07: 11.88,
          sceneRecall05: 20.54,
          scenemAP: 44.95,
          Avg: 9.92,
        },
        {
          methods: "Qwen2.5-VL-72B",
          objRecall07: 8.86,
          objRecall05: 16.82,
          objmAP: 35.95,
          sceneRecall07: 13.58,
          sceneRecall05: 27.41,
          scenemAP: 51.35,
          Avg: 11.22,
        },
        {
          methods: "Qwen-VL-Max",
          objRecall07: 12.44,
          objRecall05: 16.67,
          objmAP: 34.16,
          sceneRecall07: 17.14,
          sceneRecall05: 21.23,
          scenemAP: 40.55,
          Avg: 14.79,
        },
        {
          methods: "GPT-4o",
          objRecall07: 24.32,
          objRecall05: 38.41,
          objmAP: 63.97,
          sceneRecall07: 28.64,
          sceneRecall05: 43.95,
          scenemAP: 69.75,
          Avg: 26.48,
        },
        {
          methods: "Gemini-1.5-Flash-8B",
          objRecall07: 32.71,
          objRecall05: 40.71,
          objmAP: 59.0,
          sceneRecall07: 43.81,
          sceneRecall05: 53.35,
          scenemAP: 71.91,
          Avg: 38.26,
        },
        {
          methods: "Gemini-1.5-Flash-002",
          objRecall07: 41.41,
          objRecall05: 52.24,
          objmAP: 69.51,
          sceneRecall07: 55.41,
          sceneRecall05: 68.3,
          scenemAP: 81.85,
          Avg: 48.41,
        },
        {
          methods: "Gemini-1.5-Pro-002",
          objRecall07: 48.24,
          objRecall05: 58.35,
          objmAP: 74.3,
          sceneRecall07: 65.46,
          sceneRecall05: 75.77,
          scenemAP: 86.08,
          Avg: 56.85,
        },
        {
          methods: "Human Experts",
          objRecall07: 90.74,
          objRecall05: 88.89,
          objmAP: 91.87,
          sceneRecall07: 90.32,
          sceneRecall05: 89.25,
          scenemAP: 93.37,
          Avg: 90.53,
        },
      ],
    };
  },
  methods: {
    setActiveTabMedium(index) {
      this.activeTabMedium = index;
    },
    renderHeader(label) {
      return (h) => {
        return h("span", {
          domProps: {
            innerHTML: label,
          },
        });
      };
    },
    handleSortChange({ prop, order }) {
      if (order === "ascending") {
        this.tableDataMedium.sort((a, b) => this.sortData(a, b, prop));
      } else if (order === "descending") {
        this.tableDataMedium.sort((a, b) => this.sortData(b, a, prop));
      }
    },
    sortData(a, b, prop) {
      if (typeof a[prop] === "string" && typeof b[prop] === "string") {
        return a[prop].localeCompare(b[prop]);
      }
      return a[prop] - b[prop];
    },
    formatNumber(row, column, cellValue) {
      const value = parseFloat(cellValue || 0);
      return value.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
$tablet: 1024px; // 平板及以下（≤1024px）
$mobile: 768px; // 移动端及以下（≤768px）
.leaderboardMedium {
  margin: 40px auto 0px;
  width: 100%;
  position: relative;
  padding: 0 15px;

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    position: relative;
    z-index: 1;
  }

  .tabList {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 20px;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 36px;
      width: 80px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #d0d0d0;
      text-align: left;
      font-style: normal;
      border: 1px solid rgba(208, 208, 208, 1);
      cursor: pointer;
      list-style: none;

      &:nth-child(1) {
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border-right-color: transparent;

        b {
          background: url("../../assets/images/fill_1.png") no-repeat;
          background-size: 100% 100%;
          width: 14px;
          height: 13px;
          margin-right: 5px;
        }
      }

      &:nth-child(2) {
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        border-left-color: transparent;

        b {
          background: url("../../assets/images/fill_4.png") no-repeat;
          background-size: 100% 100%;
          width: 14px;
          height: 13px;
          margin-right: 5px;
        }
      }

      &.active {
        color: rgba(255, 98, 31, 1);
        border: 1px solid rgba(255, 98, 31, 1);

        &:nth-child(1) {
          b {
            background: url("../../assets/images/fill_2.png") no-repeat;
          }
        }

        &:nth-child(2) {
          b {
            background: url("../../assets/images/fill_3.png") no-repeat;
          }
        }
      }
    }
  }

  .board_tabs_Short {
    width: 100%;

    .item {
      width: 100%;
      height: auto;
      overflow: auto !important;
    }
  }

  .table_wrapper {
    overflow-x: auto;
  }
}

// 平板适配（≤1024px）
@media (max-width: $tablet) {
  .leaderboardMedium {
    .title {
      font-size: 36px;
      margin-bottom: 25px;
    }

    .tabList li {
      width: 75px;
      font-size: 13px;
    }

    .chart_wrapper {
      height: 400px; // 缩小图表高度
    }

    // 表格字体缩小，节省空间
    ::v-deep .el-table {
      font-size: 12px;

      .el-table__header-wrapper .cell {
        font-size: 11px;
        height: 45px; // 增加表头高度，避免文字重叠
      }

      .el-table__body-wrapper .el-table__cell {
        padding: 10px 0; // 减少单元格内边距
      }
    }
  }
}

// 移动端适配（≤768px）
@media (max-width: $mobile) {
  .leaderboardMedium {
    .title {
      font-size: 26px;
      margin-bottom: 20px;
    }

    .tabList {
      margin-bottom: 15px;
    }

    .board_tabs_Short .item {
    }
  }
}

// 表格样式穿透
::v-deep {
  .el-table.Leaderboard_table {
    background-color: transparent;
    border-collapse: collapse;
    border: none !important;

    th.el-table__cell,
    td.el-table__cell {
      border: none !important;
    }

    .el-table__header-wrapper {
      .el-table__header {
        thead {
          color: #e2e2e2;

          tr {
            background: transparent;

            &:first-child {
              th.el-table__cell.is-leaf {
                vertical-align: bottom;
              }
            }
          }
        }
      }

      th.el-table__cell.is-leaf {
        border-bottom: 1px solid transparent;
      }

      th.el-table__cell {
        background-color: transparent;
        padding: 0px;

        .cell {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 40px;
          font-size: 12px;

          .caret-wrapper {
            margin-left: 5px;
          }
        }
      }

      .descending .sort-caret.descending {
        border-top-color: rgb(255, 98, 31);
      }

      .ascending .sort-caret.ascending {
        border-bottom-color: rgb(255, 98, 31);
      }
    }

    .el-table__body-wrapper {
      .el-table__body {
        color: #e0e0e0;
        font-size: 12px;

        tr:nth-child(1) {
          color: #ff401f;
        }

        tr:nth-child(2) {
          color: #ff8653;
        }

        tr:nth-child(3) {
          color: #ffdc3c;
        }

        tr:nth-child(odd) {
          background: rgba(216, 216, 216, 0.1);
          border-radius: 16px 0px 0px 16px;

          td:nth-child(1) {
            border-radius: 16px 0px 0px 16px;
          }
        }

        tr:nth-child(even) {
          background: transparent;
          border-radius: 16px 0px 0px 16px;

          td:nth-child(1) {
            border-radius: 16px 0px 0px 16px;
          }
        }

        tr:hover > td.el-table__cell {
          background: rgba(216, 216, 216, 0.2);
          border-bottom: none !important;
        }

        .el-table__cell {
          padding: 12px 0;
          border-bottom: 1px solid transparent;
        }

        tr > .el-table__cell:nth-child(n + 3) {
          text-align: center !important;
        }
      }
    }

    .el-table--border::after,
    .el-table--group::after,
    &::before {
      background: transparent;
    }

    &::before,
    &::after {
      display: none !important;
    }
    // 滚动条样式
    .el-table__body-wrapper::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: rgba(216, 216, 216, 0.4);
      border-radius: 3px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-track {
      background: transparent;
    }
  }
}
</style>
